import { Link } from 'react-router-dom';
import { useData } from '../context/DataContext';
import Newsletter from '../components/sections/Newsletter';
import './Services.css';

export default function Services() {
  const { data, loading } = useData();
  if (loading || !data) return <div className="page">Loading...</div>;
  const { services } = data;

  return (
    <main className="page services-page">
      <div className="container">
        <div className="section-title">
          <span className="section-title__label">What We Do</span>
          <h1 className="section-title__heading">Our Services</h1>
          <p className="section-title__description">
            From web and mobile development to AI and cloud infrastructure — we build world-class digital products.
          </p>
        </div>

        <div className="services-page__grid">
          {services.map(service => (
            <div key={service.id} className="service-card">
              <div className="service-card__icon">{service.icon}</div>
              <h3 className="service-card__title">{service.title}</h3>
              <p className="service-card__description">{service.description}</p>
            </div>
          ))}
        </div>

        <section className="services-page__cta">
          <div className="services-page__cta-content">
            <h2>Have a Project in Mind?</h2>
            <p>Submit your project requirements through IWX Service and our expert team will bring your vision to life.</p>
            <div className="services-page__cta-actions">
              <Link to="/contact" className="btn btn--primary">Start a Project</Link>
              <Link to="/products" className="btn btn--outline">Explore Products</Link>
            </div>
          </div>
        </section>
      </div>
      <Newsletter />
    </main>
  );
}
